export default class IO {
    constructor(viewsArr) {
        // Parameters
        this.viewsArr = viewsArr;

        // Set flag
        this.isFirstObserve = true;

        // Setup
        this.init()
    }


    ////////////////////
    // Lifecycle
    ////////////////////
    /**
     * Init Intersection Observer
     */
    init() {
        if (!this.viewsArr.length) return;

        // Set observer options
        const observerOptions = {
            rootMargin: "-1px -1px -1px -1px",
        };

        // Set observer callback
        const onIntersect = (entries) => {
            entries.forEach((entry) => {
                // Then apply view methods
                if (entry.intersectionRatio > 0) {
                    // Inview
                    this._setInview(entry);
                } else if (!this.isFirstObserve) {
                    // Out of view
                    this._setOutOfView(entry);
                }
            });

            this.isFirstObserve = false;
        };

        //Create a single IntersectionObserver(IO) that watches all elements
        this.observer = new IntersectionObserver(onIntersect, observerOptions);

        // Observe each elements
        let index = 0;
        while (index < this.viewsArr.length) {
            const $view = this.viewsArr[index].obj.$view
            this.observe($view);
            index++;
        }
    }

    /**
     * Destroy Intersection Observer
     */
    destroy() {
        this.observer?.disconnect();
    }


    ////////////////////
    // Observers
    ////////////////////
    /**
     * Observe view
     * @param {HTMLElement}
     */
    observe($view) {
        if (!$view) return
        this.observer.observe($view);
    }

    /**
     * Unobserve view
     * @param {HTMLElement}
     */
    unobserve($view) {
        if (!$view) return
        this.observer?.unobserve($view);
    }

    
    ////////////////////
    // Inview callbacks
    ////////////////////
    /**
     * Set in view callback
     * @param {IntersectionObserverEntry}
     */
    _setInview(entry) {
        const view = this.viewsArr.filter(
            (item) => item.obj.$view === entry.target
        )[0];
        if (!view) return;
        view.obj.IOEntry = entry
        view.obj.setInteractiveState(true);
    }

    /**
     * Set out of view callback
     * @param {IntersectionObserverEntry}
     */
    _setOutOfView(entry) {
        const view = this.viewsArr.filter(
            (item) => item.obj.$view === entry.target
        )[0];
        if (!view) return;
        view.obj.IOEntry = entry
        view.obj.setInteractiveState(false);
    }
}
